/* eslint-disable max-lines */

import { t } from 'i18next';

import { PRODUCT_CATEGORIES } from '../../screens/Home/components/Menu/constants';

import { CLIENT_PAGES } from '~constants/pages';
import { BASE_URL_ROOT_DOMAIN, CURRENT_COUNTRY_ID } from '~constants/environment';
import { ANALYTICS_IDS } from '~constants/analytics';
import logoSlogan from '~assets/logo/logo-slogan.svg';

import styles from './styles.module.scss';

export const CURRENT_YEAR = new Date().getFullYear();

const titleGroupStyle = `text-medium-condensed ${styles.titleGroup}`;

const groupStyle = `column top ${styles.groupLinks}`;

const linkStyle = `text-select ${styles.linkFooter}`;

const defaultLegalLinks = [
  {
    text: t('Footer:conditions'),
    to: CLIENT_PAGES.TERMS.path,
    style: linkStyle,
    rel: 'nofollow',
    id: ANALYTICS_IDS.links.footer.conditions
  },
  {
    text: t('Footer:privacyPolicy'),
    to: CLIENT_PAGES.PRIVACY_POLICY.path,
    style: linkStyle,
    rel: 'nofollow',
    id: ANALYTICS_IDS.links.footer.privacyPolicy
  },
  {
    text: t('Footer:ethicalCode'),
    href: 'https://cdn.papajohns.cl/rules/codigo_etico_y_conducta_profesional_-_DFSI.pdf',
    style: linkStyle,
    rel: 'nofollow',
    id: ANALYTICS_IDS.links.footer.ethicalCode
  }
];

const linkBlog = BASE_URL_ROOT_DOMAIN
  ? [
      {
        text: t('Footer:blog'),
        href: `https://blog.${BASE_URL_ROOT_DOMAIN}`,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.blog
      }
    ]
  : [];

const MENU = [
  [PRODUCT_CATEGORIES.PROMO, {}],
  [PRODUCT_CATEGORIES.PIZZA, {}],
  [PRODUCT_CATEGORIES.SIDE, {}],
  [PRODUCT_CATEGORIES.DRINK, {}],
  [PRODUCT_CATEGORIES.DESSERT, {}],
  [PRODUCT_CATEGORIES.EXTRA, {}]
];
const MENU_LINKS = MENU.map(([category, config]) => ({
  text: t(`Menu:${category}`),
  style: linkStyle,
  href: t(`Footer:${category}sPath`),
  sameTab: false,
  ...config
}));

const FOOTER_LINKS_CR = [
  {
    titleGroup: t('Footer:titleGroup1'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:aboutUs'),
        to: CLIENT_PAGES.ABOUT_US.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.aboutUs
      },
      {
        text: t('Footer:ingredients'),
        to: CLIENT_PAGES.INGREDIENTS.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.ingredients
      },
      {
        text: t('Footer:workWithUs'),
        href: CLIENT_PAGES.WORK_WITH_US.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.workWithUs
      },
      {
        text: t('Footer:companyInternational'),
        href: 'https://www.papajohns.com/international',
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.companyInternational
      },
      {
        text: t('Footer:storesLocation'),
        href: CLIENT_PAGES.STORES.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.stores,
        sameTab: true
      },
      ...linkBlog
    ]
  },
  {
    titleGroup: t('Footer:titleGroup3'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:helpCenter'),
        to: CLIENT_PAGES.HELPCENTER.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.helpCenter
      },
      {
        text: t('Footer:contact'),
        to: CLIENT_PAGES.CONTACT_FORM.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.contact
      }
    ]
  },
  {
    titleGroup: t('Footer:titleGroup4'),
    titleGroupStyle,
    groupStyle,
    links: [...defaultLegalLinks]
  },
  {
    titleGroup: t('Footer:titleGroup5'),
    titleGroupStyle,
    groupStyle,
    links: MENU_LINKS
  },
  {
    titleGroup: t('Footer:titleGroup6'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:joinTheProgram'),
        to: CLIENT_PAGES.PAPA_POINTS.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.joinTheProgram
      }
    ]
  }
];

const FOOTER_LINKS_PA = [
  {
    titleGroup: t('Footer:titleGroup1'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:aboutUs'),
        to: CLIENT_PAGES.ABOUT_US.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.aboutUs
      },
      {
        text: t('Footer:ingredients'),
        to: CLIENT_PAGES.INGREDIENTS.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.ingredients
      },
      {
        text: t('Footer:workWithUs'),
        href: CLIENT_PAGES.WORK_WITH_US.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.workWithUs
      },
      {
        text: t('Footer:companyInternational'),
        href: 'https://www.papajohns.com/international',
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.companyInternational
      },
      {
        text: t('Footer:storesLocation'),
        href: CLIENT_PAGES.STORES.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.stores,
        sameTab: true
      },
      ...linkBlog
    ]
  },
  {
    titleGroup: t('Footer:titleGroup3'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:helpCenter'),
        to: CLIENT_PAGES.HELPCENTER.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.helpCenter
      },
      {
        text: t('Footer:contact'),
        to: CLIENT_PAGES.CONTACT_FORM.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.contact
      }
    ]
  },
  {
    titleGroup: t('Footer:titleGroup4'),
    titleGroupStyle,
    groupStyle,
    links: [...defaultLegalLinks]
  },
  {
    titleGroup: t('Footer:titleGroup5'),
    titleGroupStyle,
    groupStyle,
    links: MENU_LINKS
  },
  {
    titleGroup: t('Footer:titleGroup6'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:joinTheProgram'),
        to: CLIENT_PAGES.PAPA_POINTS.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.joinTheProgram
      }
    ]
  }
];

const FOOTER_LINKS_GT = [
  {
    titleGroup: t('Footer:titleGroup1'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:aboutUs'),
        to: CLIENT_PAGES.ABOUT_US.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.aboutUs
      },
      {
        text: t('Footer:ingredients'),
        to: CLIENT_PAGES.INGREDIENTS.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.ingredients
      },
      {
        text: t('Footer:workWithUs'),
        href: CLIENT_PAGES.WORK_WITH_US.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.workWithUs
      },
      {
        text: t('Footer:companyInternational'),
        href: 'https://www.papajohns.com/international',
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.companyInternational
      },
      {
        text: t('Footer:storesLocation'),
        href: CLIENT_PAGES.STORES.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.stores,
        sameTab: true
      },
      ...linkBlog
    ]
  },
  {
    titleGroup: t('Footer:titleGroup3'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:helpCenter'),
        to: CLIENT_PAGES.HELPCENTER.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.helpCenter
      },
      {
        text: t('Footer:contact'),
        to: CLIENT_PAGES.CONTACT_FORM.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.contact
      }
    ]
  },
  {
    titleGroup: t('Footer:titleGroup4'),
    titleGroupStyle,
    groupStyle,
    links: [...defaultLegalLinks]
  },
  {
    titleGroup: t('Footer:titleGroup5'),
    titleGroupStyle,
    groupStyle,
    links: MENU_LINKS
  },
  {
    titleGroup: t('Footer:titleGroup6'),
    titleGroupStyle,
    groupStyle,
    links: [
      {
        text: t('Footer:joinTheProgram'),
        to: CLIENT_PAGES.PAPA_POINTS.path,
        style: linkStyle,
        id: ANALYTICS_IDS.links.footer.joinTheProgram
      }
    ]
  }
];

export const FOOTER_LOGO = {
  default: logoSlogan
};

export const FOOTER_LINKS = {
  pa: FOOTER_LINKS_PA,
  cr: FOOTER_LINKS_CR,
  gt: FOOTER_LINKS_GT
};

const SOCIAL_LINKS_BY_COUNTRY = {
  pa: {
    instagram: 'https://www.instagram.com/papajohnspanama/?hl=es-es/',
    facebook: 'https://www.facebook.com/PapaJohnsPanama',
    tiktok: 'https://www.tiktok.com/@papajohnspanama',
    twitter: null,
    youtube: null
  },
  cr: {
    instagram: 'https://www.instagram.com/papajohnscr/?hl=es-es/',
    facebook: 'https://www.facebook.com/papajohnscr',
    tiktok: 'https://www.tiktok.com/@papajohnscr',
    twitter: null,
    youtube: null
  },
  gt: {
    instagram: 'https://www.instagram.com/papajohnsgt/',
    facebook: 'https://www.facebook.com/papajohnsgt',
    twitter: 'https://twitter.com/papajohnsgt',
    tiktok: 'https://www.tiktok.com/@papajohnsgt',
    youtube: null
  }
};

export const SOCIAL_LINKS = SOCIAL_LINKS_BY_COUNTRY[CURRENT_COUNTRY_ID];
